<template>
  <div>
    <div v-if="loading">
      Loading...
    </div>
    <div v-if="error" class="error">
      {{ error }}
    </div>
    <div v-if="record" class="card">
      <div class="card-header">
        <div class="pull-right">
          <record-edit-button></record-edit-button>
        </div>
      </div>
      <div class="card-body">
        <h4 class="card-title">{{ record.name }} {{ record.apn }}</h4>
        <p class="card-text">
        <div class="row">
          <div class="col-sm-9">
            <table class="table table-sm">
              <thead>
              <tr>
                <th>NAME</th>
                <th>APN</th>
                <th>TRA</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>{{ record.name }}</td>
                <td>{{ record.apn }}</td>
                <td>{{ record.tra }}</td>
              </tr>
              <tr>
                <th>Deferral Process</th>
                <th>Re-Recorded Deferral</th>
                <th>Acreage</th>
              </tr>
              <tr>
                <td>{{ record.deferral_process }}</td>
                <td>{{ record.re_recorded_deferral }}</td>
                <td>{{ record.acreage }}</td>
              </tr>
              <tr>
                <th>Deferred Amount</th>
                <th>Accrued Interest</th>
                <th>Agency</th>
              </tr>
              <tr>
                <td>{{ formatCurrency(record.deferred_amount) }}</td>
                <td>{{ formatCurrency(record.accrued_interest) }}</td>
                <td><span v-if="record.agency">{{ record.agency.text }}</span></td>
              </tr>
              <tr>
                <th>Life to Date Deferrals</th>
                <th>Deferral Value</th>
                <th>Interest Component</th>
              </tr>
              <tr>
                <td>{{ formatCurrency(record.life_to_date_deferral) }}</td>
                <td>{{ formatCurrency(record.deferral_value) }}</td>
                <td>{{ formatCurrency(record.interest_component) }}</td>
              </tr>
              <tr>
                <th>Correspondence</th>
                <th>State</th>
                <th>Modified</th>
              </tr>
              <tr>
                <td>
                  <view-correspondence-button v-if="record.correspondence"></view-correspondence-button>
                  <span v-else>None</span></td>
                <td><span v-if="record.state">{{ record.state.text }}</span></td>
                <td>{{ formatDateTime(record.modified) }}</td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="col-sm-3">
            <div v-if="record.geo_json">
              <map-detail></map-detail>
            </div>
          </div>
        </div>
        <div v-if="record.notes" class="row">
          <div class="col-sm-12">
            <strong>Notes:</strong>
            <pre>{{ record.notes }}</pre>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-4">
            <record-hierarchy v-bind:record="record"></record-hierarchy>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RecordEditButton from "./RecordEditButton";
import RecordHierarchy from "./RecordHierarchy";
import MapDetail from "./MapDetail";
import CurrencyMixin from "../mixins/CurrencyMixin";
import DateTimeMixin from "../mixins/DateTimeMixin";
import ViewCorrespondenceButton from "./ViewCorrespondenceButton";
import ViewAgreementButton from "./ViewAgreementButton";

export default {
  name: "record-detail",
  components: {
    RecordEditButton,
    RecordHierarchy,
    MapDetail,
    ViewCorrespondenceButton,
    ViewAgreementButton
  },
  mixins: [CurrencyMixin, DateTimeMixin],
  computed: {
    record: {
      get() {
        return this.$store.getters.record;
      }
    },
    variables: {
      get() {
        return this.$store.getters.variables;
      }
    }
  },
  data() {
    return {
      loading: false,
      error: null,
      showModal: false
    };
  },
  mounted: function() {
    this.fetchData();
  },
  watch: {
    $route: "fetchData",
    variables: "fetchData"
  },
  methods: {
    fetchData() {
      let self = this;
      this.$store.dispatch("loadRecord", { id: this.$route.params.id }).then(
        function() {
          self.$emit("record-ready");
        },
        error => {
          self.error = error;
          self.ready = true;
        }
      );
    }
  }
};
</script>

<style>
.link {
  fill: none;
  stroke: #000;
}

.border {
  fill: none;
  shape-rendering: crispEdges;
  stroke: #aaa;
}

.node {
  stroke: #fff;
}
</style>
